<template>
  <div class="menu__body">
    <div class="menu__nav-col" v-if="user.entity_id === 2">
      <ul class="menu__nav">
        <li class="menu__nav-item">
          <template v-if="!isMobile">
            <router-link
              to="/student-schedule"
              class="menu__nav-link"
              :class="{ active: $route.path === '/student-schedule' }"
            >
              <img src="images/Schedule.svg" alt="" class="white" />

              <span>מערכת שעות</span>
            </router-link>
          </template>
          <div
            v-else
            class="menu__nav-link"
            :class="{ active: $route.path === '/student-schedule' }"
            @click="menuItemClick('/student-schedule', 0)"
          >
            <img src="images/Schedule.svg" alt="" class="white" />
            <span>מערכת שעות</span>
          </div>
        </li>
        <li
          class="menu__nav-item"
          :class="{ active: $route.path === '/student-security' }"
        >
          <template v-if="!isMobile">
            <router-link
              to="/student-security"
              class="menu__nav-link"
              :class="{ active: $route.path === '/student-security' }"
            >
              <icon name="menu-new-icon-11" class="white" />
              <span> אישורים</span>
            </router-link>
          </template>
          <div
            v-else
            class="menu__nav-link"
            :class="{ active: $route.path === '/student-security' }"
            @click="menuItemClick('/student-security', 0)"
          >
            <icon name="menu-new-icon-11" class="white" />

            <span> אישורים</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="menu__nav-col" v-if="user.entity_id !== 2">
      <ul class="menu__nav">
        <!-- Дашборд — домик -->
        <li class="menu__nav-item">
          <template v-if="!isMobile">
            <router-link
              to="/mobile-dashbord"
              class="menu__nav-link"
              :class="{ active: $route.path === '/mobile-dashbord' }"
            >
              <icon name="menu-new-icon-1" class="white" />
              <span>ראשי</span>
            </router-link>
          </template>
          <div
            v-else
            class="menu__nav-link"
            :class="{ active: $route.path === '/mobile-dashbord' }"
            @click="menuItemClick('/mobile-dashbord', 0)"
          >
            <icon name="menu-new-icon-1" class="white" />
            <span>ראשי</span>
          </div>
        </li>
        <!-- Учреждения — здание -->
        <li
          class="menu__nav-item"
          v-if="
            $perm('student.list', selectedCampus.id) ||
            $perm('student.show', selectedCampus.id)
          "
        >
          <template v-if="!isMobile">
            <router-link
              to="/administration-tables?tab=administration"
              class="menu__nav-link"
              :class="{ active: $route.path === '/administration-tables' }"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="white"
                style="color: #fff"
              >
                <path d="M3 21h18" />
                <path d="M5 21V7l8-4v18" />
                <path d="M19 21V11l-6-4" />
                <path d="M9 9v.01" />
                <path d="M9 12v.01" />
                <path d="M9 15v.01" />
                <path d="M9 18v.01" />
              </svg>
              <span>ניהול מסגרות</span>
            </router-link>
          </template>
          <div
            v-else
            class="menu__nav-link"
            :class="{
              active: $route.path.indexOf('/administration-tables') === 0
            }"
            @click="
              menuItemClick('/administration-tables?tab=administration', 0)
            "
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="white"
              style="color: #fff"
            >
              <path d="M3 21h18" />
              <path d="M5 21V7l8-4v18" />
              <path d="M19 21V11l-6-4" />
              <path d="M9 9v.01" />
              <path d="M9 12v.01" />
              <path d="M9 15v.01" />
              <path d="M9 18v.01" />
            </svg>
            <span>ניהול מסגרות</span>
          </div>
        </li>
      </ul>
      <ul
        class="menu__nav"
        v-for="(menu, menuIndex) in newMenu"
        :key="menuIndex"
      >
        <template v-for="(item, index) in menu">
          <li v-if="item.show" :key="index" class="menu__nav-item">
            <component
              :is="!isMobile ? 'router-link' : 'div'"
              :to="item.url"
              class="menu__nav-link"
              :class="{
                active:
                  $route.path === item.url ||
                  $route.path.startsWith(item.url.replace(/\/day$/, '')) ||
                  (!!item.child_url_name &&
                    $route.name === item.child_url_name) ||
                  ($route.meta.part !== 'students' &&
                    !item.center &&
                    // Items without a `part` key (e.g. טפסים) must not match
                    // routes without a slug param: undefined === undefined.
                    !!item.part &&
                    $route.params.slug === item.part)
              }"
              active-class="active"
              @click="menuItemClick(item.url, item.showMenuMobile)"
              tabindex="0"
              @keyup.enter="menuItemClick(item.url, item.showMenuMobile)"
            >
              <img
                v-if="item.center"
                :src="
                  item.img.includes('storage')
                    ? '/' + item.img
                    : '/images/centers-default.svg'
                "
                class="white"
                style="width: 24px; height: 24px"
                alt=""
              />
              <icon v-else :name="item.img" class="white" />
              <span>{{ item.name }}</span>
            </component>
          </li>
        </template>
      </ul>
      <div class="menu__user">
        <img
          :src="'/storage/' + (user ? user.img : '-')"
          alt="avatar-placeholder"
          v-avatar-placeholder
        />
      </div>
    </div>
    <div class="menu__body-inner">
      <TheSidebar v-if="user.entity_id !== 2" />
      <a href="" class="menu__exit" @click.prevent>
        <div v-if="user" class="menu__exit-title">
          <b>{{ user.full_name }}</b>
          <span>{{ user.position }}, {{ user.department }}</span>
        </div>
        <div
          @click="$emit('logout')"
          tabindex="0"
          @keyup.enter="$emit('logout')"
          class="menu__exit-svg"
        >
          <icon name="menu-new-logout" />
          <div class="tooltip top">יציאה ממערכת</div>
        </div>
      </a>
    </div>
  </div>
</template>
<style>
.menu__exit-svg {
  position: relative;
}

.menu__exit-svg:hover .tooltip {
  opacity: 1;
}
</style>
<script>
import TheSidebar from '@/Components/Layout/TheSidebar';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'NewMenu',
  components: { TheSidebar },

  props: {
    showMenu: {
      type: Boolean,
      default: false
    },
    user: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      user_global: 'auth/user'
    }),
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    ...mapState({
      selectedCampus: s => s.settings.selectedCampus
    }),
    ...mapGetters({
      selectedCampusList: 'settings/selectedCampusList',
      user_global: 'auth/user'
    }),
    showSidebar() {
      return this.$store.getters['front/getSidebarStatus'];
    },
    newMenu() {
      return [
        [
          {
            name: 'מרכז מידע',
            img: 'header__controls-link-11',
            url: '/knowledge-center-categories',
            perm: 'students',
            part: 'students',

            show:
              this.$perm(
                'knowledge_center.can_edit_the_knowledge_center',
                this.selectedCampus.id
              ) ||
              this.$perm(
                'knowledge_center.can_view_the_knowledge_center',
                this.selectedCampus.id
              ),
            showMenuMobile: 1
          },
          {
            name: 'עובדים',
            img: 'menu-new-icon-3',
            url: '/workers-list',
            perm: 'workers',
            part: 'workers',
            child_url_name: 'Worker',
            show:
              this.$perm('worker_list.show', this.selectedCampus?.id) ||
              this.$perm('worker_list.show_own', this.selectedCampus.id)
          }
        ],
        [
          {
            name: 'תלמידים',
            img: 'menu-new-icon-2',
            url: '/student-list',
            child_url_name: 'StudentEdit',
            part: 'students',
            perm: 'students',
            show: this.user_global.canSeeStudentListIcon,
            showMenuMobile: 1
          },
          {
            name: 'מערכת תלמידים',
            img: 'menu-icon-schedule-student',
            url: '/lessons-all-students',
            perm: 'students',
            part: 'lessons-all-students',
            show:
              this.$perm('student.list', this.selectedCampus?.id) ||
              this.$perm('student.show', this.selectedCampus?.id) ||
              this.$perm('menu.students', this.selectedCampus?.id),
            showMenuMobile: 1
          },
          {
            name: 'תוכניות',
            img: 'projects',
            url: '/projects',
            part: 'projects',
            child_url_name: 'MainProject',
            perm: 'students',
            show: this.$perm(
              'projects.my_be_a_project_participant',
              this.selectedCampus?.id
            ),
            showMenuMobile: 1
          },
          {
            name: 'נוכחות',
            img: 'menu-new-icon-10',
            url: '/reports',
            perm: 'students',
            part: 'reports',
            show:
              this.$perm('report.list', this.selectedCampus?.id) ||
              this.$perm('report.show', this.selectedCampus?.id)
          },
          {
            name: 'אישורים',
            img: 'menu-new-icon-11',
            url: '/students-security',
            perm: 'students',
            part: 'security',
            show: this.$perm('student.view_parents', this.selectedCampus?.id)
          },
          {
            name: 'אירועים',
            img: 'menu-new-icon-12',
            url: '/incident-blanks',
            part: 'incident',
            perm: 'students',
            show: this.$perm(
              'student.view_behavior_incidents',
              this.selectedCampus?.id
            )
          },
          {
            name: 'הורים ומשפחה',
            img: 'menu-icon-relatives',
            url: '/relatives-list',
            perm: 'students',
            part: 'relatives',
            child_url_name: 'RelativeEdit',
            show: this.$perm('relative.list', this.selectedCampus?.id)
          }
        ],
        [
          // Legacy Study Center (/centers/:slug/day) — commented out so
          // the only menu entry is v2. Restore this map to bring the old
          // calendar back into the sidebar.
          // ...this.selectedCampusList.map(item => {
          //   return {
          //     center: true,
          //     name: item.name_menu,
          //     img: item.icon || 'centers-default',
          //     url: `/centers/${item.url}/day`,
          //     part: `${item.url}`,
          //     perm: 'study-center',
          //     show: this.$perm(
          //       'study_center.can_show',
          //       this.selectedCampus?.id
          //     ),
          //     showMenuMobile: 1
          //   };
          // }),
          ...this.selectedCampusList.flatMap(item => {
            const canShowCenter =
              this.$perm('study_center.can_show', this.selectedCampus?.id) ||
              this.$perm(
                [
                  'study_center.can_see_own_lessons',
                  'study_center.can_see_all_lessons'
                ],
                this.selectedCampus?.id
              );
            if (!canShowCenter) {
              return [];
            }
            return [
              {
                center: true,
                name: item.name_menu,
                img: item.icon || 'centers-default',
                url: `/study-center-v2/${item.url}/day`,
                part: `${item.url}`,
                perm: 'study-center',
                show: true,
                showMenuMobile: 1
              }
            ];
          })
        ],
        [
          {
            name: 'אחזקה',
            img: 'menu-new-icon-9',
            url: '/service-orders?status=all',
            perm: 'maintenance',
            part: 'service-orders',

            show: this.$perm('service_orders.create', this.selectedCampus?.id),
            showMenuMobile: 1
          },
          {
            name: 'ביטחון',
            img: 'menu-new-icon-5',
            url: '/security/student',
            part: 'security-student',
            perm: 'security',
            show: this.$perm('security.can_view', this.selectedCampus?.id),
            showMenuMobile: 1
          },
          {
            name: 'מבקרים',
            img: 'menu-new-icon-4',
            url: '/own-permission',
            part: 'own_permits',
            perm: 'own_permits',
            show: this.$perm('security.can_view', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'טפסים',
            img: 'menu-new-icon-10',
            url: '/custom-blank-templates',
            perm: 'blank_dashboards',
            show:
              this.$perm('custom_blanks.can_view', this.selectedCampus?.id) ||
              this.$perm('custom_blanks.can_create', this.selectedCampus?.id) ||
              this.$perm(
                'custom_blanks.workers_can_view',
                this.selectedCampus?.id
              ) ||
              this.$perm(
                'custom_blanks.workers_can_create',
                this.selectedCampus?.id
              ),
            showMenuMobile: 1
          }
        ],
        [
          {
            name: 'הגדרות',
            img: 'menu-new-icon-8',
            url: '/settings',
            perm: 'settings',
            part: 'settings',
            show: this.$perm('settings.view', this.selectedCampus.id),
            showMenuMobile: 1
          }
        ],
        // Parent-account top-level icon (prod): visible only to relatives.
        [
          {
            name: 'אזור הורים',
            img: 'menu-new-icon-11',
            url: '/parent/exit-requests',
            perm: 'parent',
            child_url_name: 'ParentExitRequests',
            show: Number(this.user && this.user.entity_id) === 4,
            showMenuMobile: 1
          }
        ]
      ];
    }
  },
  methods: {
    ...mapActions({
      setMenuPart: 'front/setMenuPart',
      setSidebarStatus: 'front/setSidebarStatus'
    }),
    menuItemClick(path, status = 0) {
      if (path === '/service-orders?status=all') {
        this.$router.push({ path: path + '&menu-open=' + status });
      } else {
        this.$router.push({ path: path + '?menu-open=' + status });
      }
      this.setSidebarStatus(status === 1 ? true : false);
    }
  }
};
</script>

<style scoped></style>
